import AnnouncementBlock from './AnnouncementBlock';
import './style.scss';

export {
  AnnouncementBlock
};



// WEBPACK FOOTER //
// ./components/partials/announcement-block/index.js